module.exports = __webpack_public_path__ + "img/synopsis-img.b0fb7a59.jpg";